import moment from 'moment-timezone'
import { formatIntegerWithThousands, DATE_FORMAT_WITH_DOTS } from 'plankton'

const DATETIME_FORMAT_WITH_DOTS = 'DD.MM.YYYY HH:mm'

export function toKilometers(distanceInMeters) {
  if (!distanceInMeters) return '-'
  return formatIntegerWithThousands(0.001 * distanceInMeters.toFixed(0)) + 'km'
}

export function toDate(dateTimeString) {
  return moment(dateTimeString).format(DATE_FORMAT_WITH_DOTS)
}

export function toDateTime(dateTimeString) {
  return moment(dateTimeString).format(DATETIME_FORMAT_WITH_DOTS)
}
